"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollToElement = void 0;
var scrollToElement = function (_a) {
    var selector = _a.selector, _b = _a.offset, offset = _b === void 0 ? 0 : _b, _c = _a.hasAnimation, hasAnimation = _c === void 0 ? true : _c;
    if (typeof window === 'undefined'
        || typeof document === 'undefined') {
        return;
    }
    var element = document.querySelector(selector);
    if (!element) {
        return;
    }
    var html = document.documentElement;
    var body = document.body;
    var scrollTop = (html && html.scrollTop) || (body && body.scrollTop) || 0;
    var scrollLeft = (html && html.scrollLeft) || (body && body.scrollLeft) || 0;
    var _d = element.getBoundingClientRect(), top = _d.top, left = _d.left;
    var agent = window.navigator.userAgent;
    // Check if it is IE (old or new) or Edge
    var isIE = /MSIE|Trident|Edge/.test(agent);
    var offsetLeft = scrollLeft + left - offset;
    var offsetTop = scrollTop + top - offset;
    if (isIE) {
        window.scrollTo(offsetLeft, offsetTop);
    }
    else {
        window.scrollTo({
            behavior: hasAnimation ? 'smooth' : 'auto',
            left: offsetLeft,
            top: offsetTop,
        });
    }
};
exports.scrollToElement = scrollToElement;
//# sourceMappingURL=scrollToElement.js.map